import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Cookie, X } from 'lucide-react';

const T = {
  en: {
    title: 'We use cookies',
    desc: 'Strictly necessary cookies are required for ClicksyHub to work. With your consent we also use analytics and marketing cookies. You can change your preferences anytime.',
    accept: 'Accept all', reject: 'Reject all', settings: 'Customize', save: 'Save preferences',
    nec: 'Strictly necessary', necDesc: 'Required for the site to work. Always on.',
    ana: 'Analytics', anaDesc: 'Help us measure traffic and usage.',
    mkt: 'Marketing', mktDesc: 'Used to deliver relevant content.',
  },
  es: {
    title: 'Usamos cookies',
    desc: 'Las cookies estrictamente necesarias son requeridas para que ClicksyHub funcione. Con tu consentimiento usamos cookies analíticas y de marketing. Puedes cambiar tus preferencias cuando quieras.',
    accept: 'Aceptar todas', reject: 'Rechazar todas', settings: 'Personalizar', save: 'Guardar preferencias',
    nec: 'Estrictamente necesarias', necDesc: 'Requeridas para que el sitio funcione. Siempre activas.',
    ana: 'Analítica', anaDesc: 'Nos ayudan a medir tráfico y uso.',
    mkt: 'Marketing', mktDesc: 'Para entregar contenido relevante.',
  },
};

export default function CookieBanner() {
  const { lang } = useLanguage();
  const t = T[lang] || T.en;
  const [show, setShow] = useState(false);
  const [settings, setSettings] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: true, marketing: true });

  useEffect(() => {
    const v = localStorage.getItem('ch_cookies');
    if (!v) setShow(true);
  }, []);

  const save = (data) => {
    localStorage.setItem('ch_cookies', JSON.stringify({ ...data, ts: Date.now() }));
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-5 left-5 right-5 md:left-auto md:right-8 md:bottom-8 md:max-w-[460px] z-[60] rounded-md bg-[#1E1E1E] border border-[#3A332A] shadow-2xl text-[#FAF6EF]">
      <div className="p-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full border border-[#C6C4CF] flex items-center justify-center text-[#C6C4CF]"><Cookie size={18} /></div>
          <div className="flex-1">
            <h3 className="text-lg font-medium" style={{ letterSpacing: '-0.02em' }}>{t.title}</h3>
            <p className="mt-2 text-sm text-[#C6C4CF] leading-relaxed">{t.desc}</p>
          </div>
          <button onClick={() => save({ necessary: true, analytics: false, marketing: false })} className="text-[#8A8275] hover:text-[#FAF6EF]"><X size={16} /></button>
        </div>
        {settings && (
          <div className="mt-4 space-y-2">
            <Row title={t.nec} desc={t.necDesc} checked disabled />
            <Row title={t.ana} desc={t.anaDesc} checked={prefs.analytics} onChange={(v) => setPrefs((p) => ({ ...p, analytics: v }))} />
            <Row title={t.mkt} desc={t.mktDesc} checked={prefs.marketing} onChange={(v) => setPrefs((p) => ({ ...p, marketing: v }))} />
          </div>
        )}
        <div className="mt-5 flex flex-wrap items-center gap-2">
          {!settings && <button onClick={() => setSettings(true)} className="text-[11px] uppercase tracking-[0.22em] px-4 py-2.5 border border-[#3A332A] hover:border-[#F5F137] rounded-full transition-colors">{t.settings}</button>}
          <button onClick={() => save({ necessary: true, analytics: false, marketing: false })} className="text-[11px] uppercase tracking-[0.22em] px-4 py-2.5 border border-[#3A332A] hover:border-[#F5F137] rounded-full transition-colors">{t.reject}</button>
          {settings ? (
            <button onClick={() => save({ necessary: true, ...prefs })} className="ml-auto text-[11px] uppercase tracking-[0.22em] px-5 py-2.5 bg-[#FAF6EF] text-[#232323] rounded-full hover:bg-[#F5F137] transition-colors">{t.save}</button>
          ) : (
            <button onClick={() => save({ necessary: true, analytics: true, marketing: true })} className="ml-auto text-[11px] uppercase tracking-[0.22em] px-5 py-2.5 bg-[#FAF6EF] text-[#232323] rounded-full hover:bg-[#F5F137] transition-colors">{t.accept}</button>
          )}
        </div>
      </div>
    </div>
  );
}

function Row({ title, desc, checked, onChange, disabled }) {
  return (
    <label className="flex items-start justify-between gap-3 p-3 rounded-md bg-[#2A2A2A] cursor-pointer">
      <div>
        <p className="text-sm font-medium text-[#FAF6EF]">{title}</p>
        <p className="text-xs text-[#C6C4CF] mt-0.5">{desc}</p>
      </div>
      <input type="checkbox" checked={!!checked} disabled={disabled} onChange={(e) => onChange?.(e.target.checked)} className="mt-1 w-4 h-4 accent-[#C6C4CF]" />
    </label>
  );
}
